import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

import { Box, Flex, Image, ImageProps } from '@rover/kibble/core';
import MQ from '@rover/kibble/styles/MediaQuery';

import LandingHero from '../../components/LandingHero';
import LandingSearchForm, {
  Props as LandingSearchFormProps,
} from '../../components/LandingSearchForm';

type Props = {
  desktopImage: string;
  heading: string;
  subheading: string;
} & LandingSearchFormProps;

// styled image is required because kibble images don't support aspect-ratio yet
const HeroImage = styled(Image)`
  // we use aspect-ratio instead of using height auto to reduce CLS
  aspect-ratio: 1.21;
  // limit the image height to avoid it being the tallest thing in the Hero
  max-height: 400px;
`;

export const HeroImageWrapper: React.FC<ImageProps> = ({
  description,
  height,
  width,
  src,
  resizeMethod,
  webProps,
}) => {
  return (
    <>
      <Helmet>
        <link
          media={MQ.NOT_XS.getBreakpointString()}
          rel="preload"
          as="image"
          href={src as string}
          fetchPriority="high"
        />
      </Helmet>
      <HeroImage
        description={description}
        height={height}
        width={width}
        src={src}
        resizeMethod={resizeMethod}
        webProps={webProps}
      />
    </>
  );
};

const SeoLocationHero: React.FC<Props> = ({
  desktopImage,
  heading,
  subheading,
  ...landingSearchFormProps
}) => {
  return (
    <Flex
      position="relative"
      pt="8x"
      pb="0x"
      mb="2x"
      justifyContent={['center', 'space-between']}
      alignItems="center"
      width="100%"
    >
      <Flex
        width="100%"
        maxWidth="416px"
        justifyContent="center"
        flexDirection="column"
        flexBasis={['100%', '50%', '416px']}
      >
        <LandingHero.Display>{heading}</LandingHero.Display>
        <LandingHero.Text>{subheading}</LandingHero.Text>
        <LandingSearchForm {...landingSearchFormProps} />
      </Flex>
      <Box display={['none', 'block']} flexBasis="50%">
        <HeroImageWrapper
          description=""
          height="auto"
          width="100%"
          src={desktopImage}
          resizeMethod="contain"
          webProps={{
            eager: true,
            // @ts-expect-error fetchPriority is not in ImageWebOnlyProps, but is a valid img attribute
            fetchPriority: 'high',
          }}
        />
      </Box>
    </Flex>
  );
};

export default SeoLocationHero;
